import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-checkbox-empty-filled"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("rect", {
        width: "20",
        height: "20",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke",
        transform: "translate(12 12)"
      })
    ], -1)
  ]), 16))
}
export default { render: render }